import { useMemo } from 'react';
import { Goal } from '../../goals';
import { sum } from '../../util/arrays';
import { isNotNullish } from '../../util/types';
import {
    getGoalTransactionSchedules,
    getMonthlyContributionFromTransactionSchedulePlan,
    useSortedUnfilteredGoalsForPageMode,
} from '../goals';

export type GoalWithMonthlyAmount = Goal & { monthlyAmount: number };

export const useGoalData = (): {
    goals: GoalWithMonthlyAmount[] | undefined;
    loading: boolean;
} => {
    const { goals, loading } = useSortedUnfilteredGoalsForPageMode();

    return useMemo(() => {
        if (!goals || loading) {
            return { goals: undefined, loading: true };
        }

        const goalData = goals
            .map((goal) => {
                const transactionSchedules = getGoalTransactionSchedules(
                    goal
                ).filter((t) => !t.deletedAt);

                const monthlyAmount = sum(transactionSchedules, (t) =>
                    getMonthlyContributionFromTransactionSchedulePlan(t)
                );

                if (monthlyAmount === 0) return null;

                return {
                    ...goal,
                    monthlyAmount,
                };
            })
            .filter(isNotNullish);

        return { goals: goalData, loading: false };
    }, [goals, loading]);
};
